// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper___zbes","list":"styles_list__1UmHk","badgeCountContainer":"styles_badgeCountContainer__3zYJ2"};